import { Pipe, PipeTransform } from '@angular/core';
import { FormatPhoneNumberAs } from 'enumerations/format-phone-number-as';
import { parsePhoneNumber, CountryCode } from 'libphonenumber-js/min';

@Pipe({
  name: 'formatPhoneNumber'
})
export class FormatPhoneNumberPipe implements PipeTransform {

  transform(phoneValue: string, isoCountryCode: string, formatAs: FormatPhoneNumberAs): string {
    phoneValue = phoneValue.trim();
    isoCountryCode = isoCountryCode.trim();
    let transformed: string = phoneValue;

    try {
      switch (formatAs)
      {
        case FormatPhoneNumberAs.TriconCustom:
          transformed = this.formatAsTriconCustom(phoneValue, isoCountryCode);
          break;
        default:
          transformed = this.formatUsingGoogleLibrary(phoneValue, isoCountryCode, formatAs);
          break;
      }
    }
    catch (error) {
      let message: string;
      if (error instanceof Error) message = error.message; else message = String(error);
      console.warn(message);
    }
    return transformed;
  }  
    
  private formatAsTriconCustom(phoneValue: string, isoCountryCode: string): string {
    switch(isoCountryCode.toUpperCase()) {
      case "US": {
        const cleansed = phoneValue.charAt(0) === "1" ? phoneValue.substring(1, phoneValue.length) : phoneValue;
        if (cleansed.length !== 10) {
          throw `"${phoneValue}" is not a USA phone number`;
        }
        return `1-${cleansed.substring(0,3)}-${cleansed.substring(3,6)}-${cleansed.substring(6,10)}`;
      }
      default: {
        throw `Country code '${isoCountryCode}' with phone number '${phoneValue}' is not supported for Tricon custom formatting!`;
      }
    }
  }

  private formatUsingGoogleLibrary(phoneValue: string, isoCountryCode: string, formatAs: FormatPhoneNumberAs): string {
    const phoneNumber = parsePhoneNumber(phoneValue + '', isoCountryCode as CountryCode);
    return (formatAs ===  FormatPhoneNumberAs.International)
      ? phoneNumber.formatInternational() 
      : phoneNumber.formatNational();
  }

}
